import { packingTemplateIdFormat } from "@redotech/redo-fulfillment-id";
import { adjustmentSessionIdFormat } from "@redotech/redo-inventory-id";
import {
  PackingMode,
  PackingModeSchema,
} from "@redotech/redo-model/inventory/packing-mode";
import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-product-id";
import * as z from "zod";
import { AdjustmentSessionSchema } from "./create-adjustment-session";

const AdjustmentSessionProductWithDetailsSchema_ = z.object({
  productId: productIdFormat.schema,
  title: z.string(),
  sku: z.string(),
  upc: z.string().nullable(),
  barcodes: z.array(z.string()),
  imageUrl: z.string().nullable(),
  currentQuantity: z.number(),
  quantity: z.number(),
  damagedQuantity: z.number().optional(),
  missingQuantity: z.number().optional(),
  accountId: z.string().optional(),
  accountName: z.string().optional(),
  packingMode: PackingModeSchema.default(PackingMode.INDIVIDUAL),
  packingTemplateId: packingTemplateIdFormat.schema.nullable().default(null),
  packingTemplateName: z.string().nullable().default(null),
  enteredQuantity: z.number().default(0),
  unitsPerBox: z.number().nullable().default(null),
  productFamilyId: productFamilyIdFormat.schema.nullable().optional(),
  productFamilyTitle: z.string().nullable().optional(),
  optionsSortKey: z.array(z.number()).default([]),
});

export const AdjustmentSessionProductWithDetailsSchema: z.ZodType<AdjustmentSessionProductWithDetailsSchema> =
  AdjustmentSessionProductWithDetailsSchema_;
export interface AdjustmentSessionProductWithDetailsSchema extends z.infer<
  typeof AdjustmentSessionProductWithDetailsSchema_
> {}

export const getAdjustmentSession = {
  name: "getAdjustmentSession" as const,
  input: z.object({ sessionId: adjustmentSessionIdFormat.schema }),
  output: z.object({
    session: AdjustmentSessionSchema,
    products: z.array(AdjustmentSessionProductWithDetailsSchema),
  }),
};
